module.exports = __webpack_public_path__ + "static/img/caseitemplat.c32c80b3.png";